import { configureStore } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import { persistStore, persistReducer } from 'redux-persist';
import rootReducer from './rootReducer';

// Whitelist (WHEEL-334): persistence is opt-in. Only genuine cross-session
// client state may be listed here - never server-response caches or
// transient UI flags (loading/toasts/in-flight operations), which caused
// the recurring rehydration bugs (stuck spinners, stale data flashes).
// - filterList: dashboard filter preferences
// - notification: notification drawer history (capped at 1000)
// - bulkActions: orphaned-processing recovery (WHEEL-256) rehydrates an
//   interrupted run on load and auto-completes it
// (The user record is a TanStack query since WHEEL-341f - every surface
//  fetches it itself, so the old persisted-user deep-link workaround
//  (WHEEL-292/7dbb619) is no longer needed. pendingAiSummaries is transient
//  runtime state and stays excluded.)
const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['filterList', 'notification', 'bulkActions'],
};
const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
  reducer: persistedReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({ serializableCheck: false }),
});

export default store;

export const persistor = persistStore(store);
export type AppDispatch = typeof store.dispatch;
